import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import https from "https";
import axios from "axios";
import log from "../utils/log";
import metaData from "../data/metaData";
import c from "../utils/common";

//
import useAuthStore from "../states/useAuth";

const usePromotionCode = () => {
  const { auth, user } = useAuthStore();

  const createPromotionCode = async (data) => {
    //prepare body data
    data.companyId = user.companyId;
    //
    let res = await axios.post(metaData.serverURL + "promotionCode", data, {
      headers: { Authorization: auth.jwt },
      httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
    });
    return res.data;
  };

  const updatePromotionCode = async (code, data) => {
    let res = await axios.patch(metaData.serverURL + "promotionCode", data, {
      params: { code: code }, // Pass the request ID as a query parameter if needed
      headers: { Authorization: auth.jwt },
      httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
    });
    return res.data;
  };

  const deletePromotionCode = async (code) => {
    const res = await axios.delete(metaData.serverURL + "promotionCode", {
      params: { code: code },
      headers: { Authorization: auth.jwt },
      httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
    });
    return res.data;
  };

  return { createPromotionCode, updatePromotionCode, deletePromotionCode };
};

export default usePromotionCode;
